import { Component, Host, Prop, h } from '@stencil/core'

@Component({
  tag: 'bam-page-section',
  shadow: false
})
export class BamPageSection {

  @Prop() space: 'top' | 'bottom' | 'all' | 'none' = 'all'

  render() {
    return (
      <Host class={{
        'block': true,
        'pt-xx-large': this.space === 'top',
        'pb-xx-large': this.space === 'bottom',
        'py-xx-large': this.space === 'all'
        }}
      >
          <slot></slot>
      </Host>
    )
  }
}
